import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid2';
import { useFormik } from 'formik';
import dayjs from 'dayjs';
import { get_technology_with_out_pagination } from '../../../../../config/Resource/technologyApis';
import { get_worksite_with_out_pagination } from '../../../../../config/Worksite/siteApis';
import CustomBreadcrumbs from '../../../../../Components/custom_components/CustomBreadcrumbs/CustomBreadcrumbs';
import CustomTextFieldWithIcon from '../../../../../Components/custom_components/custom_text_field/CustomTextFieldWithIcon';
import CustomSelectDropdown from '../../../../../Components/custom_components/CustomSelectDropdown/CustomSelectDropdown';
import ActionButton from '../../../../../Components/custom_components/CustomButtons/ActionButton/ActionButton';
import CustomDatePicker from '../../../../../Components/custom_components/CustomDatePicker/CustomDatePicker';
import { useNavigate } from 'react-router-dom';
import CustomAddButton from '../../../../../Components/custom_components/CustomAddButton/CustomAddButton';
import CustomSearchBar from '../../../../../Components/custom_components/CustomSearchBar/CustomSearchBar';

function MyBinReportSearchFilter({ tableTitle, searchFilter, isSendPermission, handlSubmitModal, handleClearSelectedIds, on_change_value, on_page_count_update,
    handleOpenReportModal, scheduleId,

}) {

    const Navigate = useNavigate()

    const [technologyListing, setTechnologyListing] = useState([]);
    const [worksiteListing, setWorksiteListing] = useState([]);
    // const [workforceListing, setWorkforceListing] = useState([]);
    // const [equipmentListing, setEquipmentListing] = useState([]);

    const fetchTechnologies = async () => {
        try {
            const response = await get_technology_with_out_pagination();
            if (response?.status === "success") {
                // Transform data into the desired format with label and value
                const transformedData = response.data.data?.map((item) => ({
                    label: item?.TechnologiesName,
                    value: item?.TechnologiesTypeId
                }));

                // Set the transformed data to the state
                setTechnologyListing(transformedData || []);
            } else {
                setTechnologyListing([]);
            }
        } catch (error) {
            console.error('Error fetching technologies:', error);
            setTechnologyListing([]);
        }
    };

    // FETCH WORKSITES 
    const fetchSites = async () => {
        try {
            const response = await get_worksite_with_out_pagination();

            if (response?.status === "success") {
                // Transform data into the desired format with label and value
                const transformedData = response.data.data?.map((item) => ({
                    label: item?.worksiteName,
                    value: item?.WorksiteID
                }));

                // Set the transformed data to the state
                setWorksiteListing(transformedData || []);
            } else {
                setWorksiteListing([]);
            }
        } catch (error) {
            console.error('Error fetching :', error);
            setWorksiteListing([]);
        }
    };

    // FOR GET TECHNOLOGIES FROM LIST
    useEffect(() => {
        // fetchSites()
        // fetchTechnologies();
    }, []);


    const formik = useFormik({
        initialValues: {
            ScheduleCode: '',
            Survey_from_date: '',
            Survey_end_date: '',
            TechnologyId: '',
            WorksiteId: '',
            // EmployeeId: '',
            EquipmentID: '',
            movetoclient: 0,
        },
        // onSubmit: (values) => {
        //     searchFilter(values);
        //     handleClearSelectedIds()
        // },
    });

    const resetFilter = () => {
        formik.resetForm();
        handleClearSelectedIds()
        on_change_value(1)
        on_page_count_update(25)
        searchFilter(
            {
                ScheduleCode: '',
                Survey_from_date: '',
                Survey_end_date: '',
                TechnologyId: '',
                WorksiteId: '',
                EquipmentID: '',
                movetoclient: 0,
            }
        )
    }

    const breadcrumbs = ['Schedules', tableTitle]

    const handlePrev = () => {
        Navigate('/worksites/my-schedules/overview', { replace: true })
    }
    return (

        <div className="schedule-search-filter-container">
            <div className="schedule-search-filter-sub-container">
                <div className="schedule-search-filter-header">
                    <div className="schedule-search-filter-left">
                        <div className="schedule-table-title">{tableTitle}</div>
                        <CustomBreadcrumbs breadcrumbs={breadcrumbs} />
                    </div>
                    <div className="schedules-search-filter-right">
                        <ActionButton onClick={handlePrev} label="Back" btnType="primary" />
                        {/* <CustomAddButton label="To Client" onClick={handlSubmitModal} Icon={BsFillSendFill} isDisable={!isSendPermission} /> */}
                    </div>
                </div>

                <div className="search-layout-wrapper">
                    {/* <div className="report-header-container">
                        <div className="report-header-left">
                            {true && (
                                <CustomAddButton
                                    label="Add Report"
                                    onClick={() => handleOpenReportModal(null, scheduleId, null)}
                                />
                            )}
                        </div>

                        <div className="report-header-search">
                            <CustomSearchBar
                                value={searchText}
                                onChange={setSearchText}
                                placeholder="Search by Report name"
                            />
                        </div>
                    </div > */}
                    {/* <div className="search-filter-container">
                        <div className="search-inputs-fields">
                            <Grid item xs={12} sm={6} md={2}>
                                <CustomTextFieldWithIcon
                                    name="ScheduleCode"
                                    placeholder="Enter Schedule Code"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.ScheduleCode}
                                    width="200px"
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={2}>
                                <CustomSelectDropdown
                                    name="TechnologyId"
                                    placeholder="Select Technology"
                                    options={technologyListing}
                                    value={technologyListing.find((tech) => tech.value === formik.values.TechnologyId) || ""}
                                    onChange={(selectedOption) => {
                                        formik.setFieldValue("TechnologyId", selectedOption ? selectedOption.value : "");
                                    }}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.TechnologyId && Boolean(formik.errors.TechnologyId)}
                                    helperText={formik.touched.TechnologyId && formik.errors.TechnologyId}
                                    isDisabled={false}
                                    isMulti={false}
                                    width="200px"
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={2}>
                                <CustomSelectDropdown
                                    name="WorksiteId"
                                    placeholder="Select Worksite"
                                    options={worksiteListing}
                                    value={worksiteListing.find((w) => w.value === formik.values.WorksiteId) || ""}
                                    onChange={(selectedOption) => {
                                        formik.setFieldValue("WorksiteId", selectedOption ? selectedOption.value : "");
                                    }}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.WorksiteId && Boolean(formik.errors.WorksiteId)}
                                    helperText={formik.touched.WorksiteId && formik.errors.WorksiteId}
                                    isDisabled={false}
                                    isMulti={false}
                                    width="200px"
                                />
                            </Grid>

                         
                            <Grid item xs={12} sm={6} md={2}>
                                <CustomDatePicker
                                    name="Survey_from_date"
                                    label="From Date"
                                    onChange={(date) => {
                                        formik.setFieldValue("Survey_from_date", date);
                                    }}
                                    onBlur={formik.handleBlur}
                                    value={dayjs(formik.values.Survey_from_date, "DD-MM-YYYY")}
                                    width="200px"
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={2}>
                                <CustomDatePicker
                                    name="Survey_end_date"
                                    label="End Date"
                                    onChange={(date) => {
                                        formik.setFieldValue("Survey_end_date", date);
                                    }}
                                    onBlur={formik.handleBlur}
                                    value={dayjs(formik.values.Survey_end_date, "DD-MM-YYYY")}
                                    minDate={dayjs(formik.values.Survey_from_date, "DD-MM-YYYY")} // Set minimum date

                                    width="200px"
                                />
                            </Grid>

                        </div>

                        <div className="search-buttons-fixed-right">
                            <ActionButton
                                onClick={() => {
                                    on_change_value(1)
                                    handleClearSelectedIds()
                                    searchFilter({ ...formik.values });
                                }}
                                btnDisable={false}
                                label="Search"
                                btnType="primary"
                            />
                            <ActionButton label="Reset" btnType="outlined" onClick={resetFilter} />
                        </div>
                    </div> */}
                </div>
            </div>
        </div>

    );
}

export default MyBinReportSearchFilter;


// <div className="search-filter-container">
//         <div className="search-inputs">
//             <Grid item xs={12} sm={6} md={2}>
//                 <CustomTextFieldWithIcon
//                     name="ScheduleCode"
//                     placeholder="Enter Schedule Code"
//                     onChange={formik.handleChange}
//                     onBlur={formik.handleBlur}
//                     value={formik.values.ScheduleCode}
//                 />
//             </Grid>

//             <Grid item xs={12} sm={6} md={2}>
//                 <CustomSelectDropdown
//                     name="TechnologyId"
//                     placeholder="Select Technology"
//                     options={technologyListing}
//                     value={technologyListing.find((tech) => tech.value === formik.values.TechnologyId) || ""}
//                     onChange={(selectedOption) => {
//                         formik.setFieldValue("TechnologyId", selectedOption ? selectedOption.value : "");
//                     }}
//                     onBlur={formik.handleBlur}
//                     error={formik.touched.TechnologyId && Boolean(formik.errors.TechnologyId)}
//                     helperText={formik.touched.TechnologyId && formik.errors.TechnologyId}
//                     isDisabled={false}
//                     isMulti={false}
//                 />
//             </Grid>

//             <Grid item xs={12} sm={6} md={2}>
//                 <CustomSelectDropdown
//                     name="WorksiteId"
//                     placeholder="Select Worksite"
//                     options={worksiteListing}
//                     value={worksiteListing.find((w) => w.value === formik.values.WorksiteId) || ""}
//                     onChange={(selectedOption) => {
//                         formik.setFieldValue("WorksiteId", selectedOption ? selectedOption.value : "");
//                     }}
//                     onBlur={formik.handleBlur}
//                     error={formik.touched.WorksiteId && Boolean(formik.errors.WorksiteId)}
//                     helperText={formik.touched.WorksiteId && formik.errors.WorksiteId}
//                     isDisabled={false}
//                     isMulti={false}
//                 />
//             </Grid>

//             <Grid item xs={12} sm={6} md={2}>
//                 <CustomDatePicker
//                     name="Survey_from_date"
//                     label="From Date"
//                     onChange={(date) => {
//                         formik.setFieldValue("Survey_from_date", date);
//                     }}
//                     onBlur={formik.handleBlur}
//                     value={dayjs(formik.values.Survey_from_date, "DD-MM-YYYY")}
//                 />
//             </Grid>

//             <Grid item xs={12} sm={6} md={2}>
//                 <CustomDatePicker
//                     name="Survey_end_date"
//                     label="End Date"
//                     onChange={(date) => {
//                         formik.setFieldValue("Survey_end_date", date);
//                     }}
//                     onBlur={formik.handleBlur}
//                     value={dayjs(formik.values.Survey_end_date, "DD-MM-YYYY")}
//                 />
//             </Grid>
//         </div>

//         <div className="search-buttons-fixed-right">
//             <button className="search-btn">Search</button>
//             <button className="reset-btn">Reset</button>
//         </div>
//     </div>